const gaClient = {
  clientId: process.env.GA_CLIENT_ID,
};

export default gaClient;
